<template>
  <v-container>
    <v-card
      class="px-5 py-6 d-flex justify-space-between align-center"
      color="gray10"
      flat
    >
      <div>
        <v-icon clr="var(--v-primary-base)">$lockPasswordInput</v-icon>
        {{ $t("accountPage.setting.language.changeLanguageShort") }} :
        <span class="primary--text">{{ convertLang }}</span>
      </div>
      <div>
        <v-btn @click="isOpenDialog = true" outlined color="primary">{{
          $t("accountPage.setting.language.changeLanguageShort")
        }}</v-btn>
      </div>
    </v-card>

    <v-card class="px-5 py-6 mt-4" color="gray10" flat>
      <div>{{ $t("accountPage.setting.appearance.changeColor") }}</div>
      <div>
        {{ $t("accountPage.setting.appearance.changeColorDescription") }}
      </div>

      <div
        class="d-flex flex-column flex-sm-row align-center mt-8"
        style="gap: 30px"
      >
        <v-card
          flat
          height="200"
          class="custom-card"
          :class="{ active: theme === 'dark' }"
        >
          <v-img
            src="@/assets/image/dark.svg"
            alt=""
            width="100%"
            height="124"
          />
          <v-radio-group @change="changeTheme" v-model="theme" column>
            <v-radio
              :label="$t('accountPage.setting.appearance.darkMode')"
              value="dark"
            ></v-radio>
          </v-radio-group>
        </v-card>

        <v-card
          flat
          height="200"
          class="custom-card"
          :class="{ active: theme === 'light' }"
        >
          <img
            src="@/assets/image/light.svg"
            alt=""
            width="100%"
            height="124"
          />
          <v-radio-group @change="changeTheme" v-model="theme" column>
            <v-radio
              :label="$t('accountPage.setting.appearance.lightMode')"
              value="light"
            ></v-radio>
          </v-radio-group>
        </v-card>
      </div>
    </v-card>

    <v-dialog v-model="isOpenDialog" width="500">
      <v-card color="gray10">
        <v-container>
          <v-row no-gutters>
            <v-btn
              icon
              @click="isOpenDialog = false"
              class="position-absolute modal-close"
            >
              <v-icon>$modalClose</v-icon>
            </v-btn>
          </v-row>
          <v-row>
            <v-col>
              <v-container>
                <v-row class="flex-column text-center">
                  <div class="font-Medium-16 mb-6">
                    {{ $t("accountPage.setting.language.changeLanguage") }}
                  </div>
                  <span>
                    {{
                      $t(
                        "accountPage.setting.language.changeLanguageDescription"
                      )
                    }}
                  </span>
                </v-row>
                <div class="mt-8">
                  <v-card
                    v-for="item in languageList"
                    :key="item.value"
                    flat
                    class="px-4 mt-4"
                    :class="{ active: item.value === selectedLang }"
                  >
                    <v-radio-group v-model="selectedLang" column>
                      <v-radio
                        :label="item.title"
                        :value="item.value"
                      ></v-radio>
                    </v-radio-group>
                  </v-card>
                </div>
                <v-btn
                  block
                  text
                  @click="confirm(selectedLang)"
                  class="pa-6 primary mt-8"
                >
                  {{ $t("accountPage.setting.actions.confirmChanges") }}
                </v-btn>
              </v-container>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-dialog>
    <v-col />
  </v-container>
</template>

<script>
import UserService from "@/services/modules/userService";
export default {
  name: "index",
  data() {
    return {
      theme: this.$vuetify.theme.dark ? "dark" : "light",
      isOpenDialog: false,
      selectedLang: this.$i18n.locale,
      languageList: [
        {
          title: this.$t("languages.farsi"),
          value: "fa"
        },
        {
          title: this.$t("languages.english"),
          value: "en"
        }
      ]
    };
  },
  methods: {
    changeTheme() {
      this.$vuetify.theme.dark = !this.$vuetify.theme.dark;
      localStorage.setItem("isDark", this.$vuetify.theme.dark);
      this.setUserAccountSettings({
        theme: this.$vuetify.theme.dark ? "DARK" : "LIGHT"
      });
    },
    confirm(lang) {
      let currentLang = localStorage.getItem("lang");
      if (currentLang === lang) {
        return;
      }
      localStorage.setItem("lang", lang);
      this.$cookies.set("lang", lang);
      this.setUserAccountSettings({
        language: lang
      }).then(() => {
        this.$vuetify.rtl = lang === "en" ? false : true;
        this.$i18n.locale = lang;
      });
    },
    setUserAccountSettings(payload) {
      return UserService.saveUserAccountSetting(payload);
    }
  },
  computed: {
    convertLang() {
      switch (this.$i18n.locale) {
        case "fa":
          return "فارسی";
        case "en":
          return "English";
        default:
          return "نامشخص";
      }
    }
  }
};
</script>

<style scoped lang="scss">
.custom-card {
  width: 230px;
  padding: 12px;
}
.active {
  border: 2.77px solid var(--v-primary-base) !important;
}
</style>
